import { Injectable } from '@angular/core';
import { 
  ListPagedHomeIfcFilesRequest,
  ListPagedHomeIfcFilesResponse,
  ListPagedIfcErrorsRequest,
  ListPagedIfcErrorsResponse,
  SituViewWebApiClient
} from 'situview-webapi-client';
import { Cache } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class IfcService {

  constructor(
    private situViewClient: SituViewWebApiClient
  ) {}

  @Cache({
    duration: 100000
  })
  GetIfcReportData(request: ListPagedHomeIfcFilesRequest): Promise<ListPagedHomeIfcFilesResponse> {
    return this.situViewClient.listPagedHomeIfcFiles(request);
  }

  GetIfcReportDataUncached(request: ListPagedHomeIfcFilesRequest): Promise<ListPagedHomeIfcFilesResponse> {
    return this.situViewClient.listPagedHomeIfcFiles(request);
  }
  
  @Cache({
    duration: 50000
  })
  GetIfcReportErrorData(request: ListPagedIfcErrorsRequest): Promise<ListPagedIfcErrorsResponse> {
    return this.situViewClient.listPagedIfcFileErrors(request);
  }

  GetIfcReportErrorDataUncached(request: ListPagedIfcErrorsRequest): Promise<ListPagedIfcErrorsResponse> {
    return this.situViewClient.listPagedIfcFileErrors(request);
  }
}